import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
	FaEnvelope,
	FaPhone,
	FaFacebook,
	FaTwitter,
	FaLinkedin,
	FaInstagram,
} from "react-icons/fa";
import './Contact.css';
import animationData from './animation.json'
import Lottie from "react-lottie";

const Contact = () => {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
	};
	return (
		<div className="contact-container">
			<h2 className="section-header">Contact</h2>
			<div className="Subtitle">Call us up - help us help you.</div>
			<Container>
				<Row>
					<Col md={4} className="animation-img">
						<Lottie options={defaultOptions} />
					</Col>
					<Col md={4} className="footer-section">
						<h4>Contact Us</h4>
						<p>
							<FaEnvelope /> Email: email@example.com
						</p>
						<p>
							<FaPhone /> Phone: +91 99999 99999
						</p>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default Contact;